import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

// import * as AppPropTypes from '../../lib/PropTypes';
import { useTheme } from '../../contexts/ThemeContext';
import SportGroupPill from '../items/SportGroupPill';
import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/lists/sport-groups-pills.module.scss';

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    answeredGroup: PropTypes.string,
    isDark: PropTypes.bool,
    onGroupClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    items: null,
    answeredGroup: null,
    isDark: false,
    onGroupClick: null,
    className: null,
};

function SportGroupsPills({ items, answeredGroup, isDark, onGroupClick, className }) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                className,
            ])}
        >
            {items.map((group, periodIndex) => {
                const { id, label, canAnswer } = group || {};
                return (
                    <SportGroupPill
                        key={`period-${periodIndex + 1}`}
                        label={label}
                        answered={id === answeredGroup}
                        unlocked={canAnswer}
                        isDark={isDark}
                        onClick={() => {
                            if (onGroupClick !== null) {
                                onGroupClick(group);
                            }
                        }}
                        iconClassName={styles.periodIcon}
                        className={styles.period}
                    />
                );
            })}
        </div>
    );
}

SportGroupsPills.propTypes = propTypes;
SportGroupsPills.defaultProps = defaultProps;

export default SportGroupsPills;
